import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchDeleteBulkContactFailure,
  fetchDeleteBulkContactSuccess,
} from "../slices/features/deleteContact";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* deleteBulkContactSaga(action: any) {
  const { payload } = action;
  const { data, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.deleteBulkContact,
      baseUrl,
      data,
      meta
    );

    yield put(fetchDeleteBulkContactSuccess({ ...response }));
    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchDeleteBulkContactFailure({ statusCode, statusText }));
  }
}

export function* watchDeleteBulkContact() {
  yield takeLatest(RequestTypes.DELETE_BULK_CONTACTS, deleteBulkContactSaga);
}
